import Skeleton from '@mui/material/Skeleton'

const HeaderSkeleton = () => <Skeleton variant="rectangular" height={64} />

export default HeaderSkeleton
